<!-- 页脚 -->

<template>
  <footer>
    <div class="f_container">
      <ul class="nav linkNav">
        <li class="useful_link"><a @click="showAboutTruthso" target="_blank">关于真相搜索</a>&nbsp;&nbsp;-&nbsp;&nbsp;</li>
        <li class="useful_link" @click="userAgree">用户协议</li>
        <li class="useful_link">&nbsp;&nbsp;-&nbsp;&nbsp;<router-link to="/feedback/">问题反馈</router-link></li>
      </ul>
      <ul class="nav">
        <li class="company_info">Copyright@2013 - {{yearTime}} All rights reserved&nbsp;&nbsp;-&nbsp;&nbsp;</li>
        <li class="company_info">版权所有：真相网络科技（北京）有限公司</li>
      </ul>
      <ul class="nav">
        <li class="company_info"><a href="https://beian.miit.gov.cn/" target="_blank">京ICP备16033891号-1</a>&nbsp;&nbsp;-&nbsp;&nbsp;</li>
        <li class="company_info">公京检第1792001号&nbsp;&nbsp;-&nbsp;&nbsp;</li>
        <li class="company_info"><a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502037213"><i></i> 京公网安备案11010502037213号</a>&nbsp;&nbsp;-&nbsp;&nbsp;</li>
        <li class="company_info">公安部安全与警用电子产品质量检测中心&nbsp;&nbsp;&nbsp;&nbsp;</li>
        <li class="company_info">国家安全防范报警系统产品质量监督检验中心（北京）</li>
      </ul>
    </div>
  </footer>
</template>

<style>
  footer {
    position: fixed;
    bottom: 1.25rem;
    width: 100%;
  }

  .f_container {
    width: 1024px;
    margin: 0 auto;
    overflow: hidden;
  }

  .f_container .nav {
    height: 1.25rem;
    line-height: 1.25rem;
    color: #fff;
    font-size: 12px;
    text-align: center;
  }

  .f_container .nav li,
  .f_container .nav li a{
    color: white;
    /*padding: 0 0.4rem;*/
    text-decoration: none;
  }
.f_container .nav li a i{
    width: 20px;
    height: 20px;
    display: inline-block;
    vertical-align: middle;
    background: url(../../assets/images/common/gongan.png)
}
  .f_container .nav li{
    /*border-right: 1px solid white;*/
  }

  .f_container .nav li:nth-last-child(1){
    border-right: 0;
  }

  .f_container .nav .company_info{
    /*font-size: 0.875rem;*/
  }

  .f_container .nav .useful_link{
    /*font-size: 0.875rem ;*/
    cursor: pointer;
  }
  .useful_link:hover,.useful_link a:hover{
    color: #A12935 !important;
  }
  .f_container .linkNav{
    margin-bottom: 18px;
  }
  .f_container .linkNav > li{
    font-size: 0.8rem; 
  }
</style>

<script>

  export default {
    name: 'sfooter',
    data () {
      return {
        yearTime:new Date().getFullYear() 
      }
    },
    methods: {
      userAgree () {
        this.$store.commit('showUserAgree',true);
      },
      showAboutTruthso () {
        this.$store.commit('showAboutTruthso', true);
      }
    }
  }
</script>



// WEBPACK FOOTER //
// SFooter.vue?ff7d8758